import { render, staticRenderFns } from "./pdf-add-file.vue?vue&type=template&id=3a3f6951&scoped=true"
import script from "./pdf-add-file.vue?vue&type=script&lang=js"
export * from "./pdf-add-file.vue?vue&type=script&lang=js"
import style0 from "./pdf-add-file.vue?vue&type=style&index=0&id=3a3f6951&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3f6951",
  null
  
)

export default component.exports